import { render, staticRenderFns } from "./TaxEditor.vue?vue&type=template&id=4bbe3680&"
import script from "./TaxEditor.vue?vue&type=script&lang=js&"
export * from "./TaxEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports